import React from "react";
import "./Products.css"; // Custom CSS for styling
import { Link } from "react-router-dom";

const Products = () => {
  const products = [
    {
      href: "/contactus",
      imgClass: "flow-gallery__item-pict-1",
      title: "Host Events",
      description:
        "Check accessibility and book at no additional booking expenses!",
    },
    {
      href: "/contactus",
      imgClass: "flow-gallery__item-pict-2",
      title: "Budget Friendly",
      description:
        "Multiple payment choice  best to serve like credit card, UPI",
    },
    {
      href: "/contactus",
      imgClass: "flow-gallery__item-pict-3",
      title: "Sports Coaching",
      description: "Give your child best atmosphere for sport at MRG academy",
    },
    {
      href: "/contactus",
      imgClass: "flow-gallery__item-pict-4",
      title: "Well Maintained Infrastructure",
      description: "MRG Sports Club: Your All-in-One Sports Haven!",
    },
  ];

  return (
    <div className="products-container">
      <div className="section baseline flowgallery">
        <div className="blog-box-head mg-btm-sm-header">
          <div className="div-block-8">
            <h2 className="header-small">Your Sporting Journey </h2>
          </div>
          <div className="div-block-9">
            <Link to="/gallery" className="link_small">
              All Benefits
            </Link>
            <div className="text-block">{products.length}</div>
          </div>
        </div>
        <div className="flow-gallery">
          <div className="flow-gallery__items">
            {products.map((product, index) => (
              <Link
                key={index}
                to={product.href}
                className="flow-gallery__item"
              >
                <div className="flow-gallery__item-img">
                  <div
                    className={`flow-gallery__item-pict ${product.imgClass}`}
                  />
                </div>
                <h3 className="heading-accent flow-gallery__item-header">
                  {product.title}
                </h3>
                <div className="description-text">{product.description}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
